<template>
  <ItineraryModal
    v-if="itinerary"
    :isOpen="isOpen"
    :tripTitle="hikeName"
    :itinerary="itinerary"
    @close="isOpen = false"
  />
</template>

<script setup>
// Standalone mount of the shared Itinerary modal for the (server-rendered)
// hike overview page — read-only, built from the saved hike's HikeDay
// records via GraphQL rather than the planner's live Vuex store.
//
// The hikes list mounts it too (apps/hikes/hikeMenuModals.ts) and passes the
// hike to open each time, since there the hike changes per click; the overview
// opens it with no argument for the page's own hike.
import { ref, onMounted } from 'vue'
import ItineraryModal from '../components/ItineraryModal.vue'
import graph_client from '../../utils/graphql/graph_client'
import { GetHikeItinerary } from '../../utils/graphql/hikes-graph'
import { buildItineraryFromHikeDays } from '../components/itinerary/buildItineraryFromHikeDays'

const config = window.itineraryOverviewConfig || {}
const isOpen = ref(false)
const itinerary = ref(null)
const hikeId = ref(config.hikeId || null)
const hikeName = ref(config.hikeName || '')
let loadedHikeId = null

async function ensureLoaded() {
  if (!hikeId.value || (itinerary.value && loadedHikeId === hikeId.value)) return
  const requested = hikeId.value
  const data = await graph_client.request(GetHikeItinerary, { id: requested })
  // A slower answer for a hike opened before this one must not replace it.
  if (requested !== hikeId.value) return
  itinerary.value = buildItineraryFromHikeDays(data.hike.hikeDays)
  loadedHikeId = requested
}

onMounted(() => {
  // Exposed so the ERB "Itinerary" menu item (and the hikes list's ⋮ menu) can open the modal.
  window.openItineraryModal = async (target) => {
    if (target?.hikeId) {
      hikeId.value = String(target.hikeId)
      hikeName.value = target.hikeName || ''
    }
    await ensureLoaded()
    isOpen.value = true
  }
})
</script>
